import React from 'react';

const CadModelingBanner = () =>{
    return (
        <>
        <div className='cadModelingMain cadAboutBanner cadContactBanner'>
            <img 
            src="/assets/cad-modeling-banner.webp"
            alt="cad-modeling-banner" />
            <div className='container'>
                <div className='cadContactBannerContent'>
                    <h1><span>3</span>D CAD Modeling</h1>
                </div>
            </div>
        </div>
        </>
    );
}

export default CadModelingBanner;